<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo},
    data() {
        return {
            step: 1,
            user: {
                first_name: '',
                last_name: '',
                pesel: '',
                email: '',
                password: '',
                password_confirmation: '',
            },
            verification: {
                code: ''
            },
            termsAccepted: false,
            privacyAccepted: false,
            loading: false,
            errors: {}
        }
    },
    methods: {
        submitStep1() {
            this.loading = true;
            this.errors = {};
            axios.post('/auth/register', this.user).then(() => {
                this.step = 2;
            }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            });
        },
        submitStep2() {
            this.loading = true;
            this.errors = {};
            axios.post('/auth/register/complete', {
                ...this.user,
                ...this.verification,
            }).then(async (response) => {
                await this.$auth.loginWithToken(response.data.token)
                this.$router.push({name: 'home'});
            }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}

</script>
<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <a href="/"><Logo/></a>
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-4-desktop is-4-widescreen">

                        <form v-if="step === 1" @submit.prevent="submitStep1" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('auth.sign_up.title_label') }}
                            </p>
                            <div class="box no-top-radius">

                                <b-field :label="$t('users.fields.first_name.name')" custom-class="mb-3"
                                         label-for="first_name"
                                         :type="errors.first_name ? 'is-danger' : null"
                                         :message="errors.first_name ? errors.first_name[0] : null">
                                    <b-input
                                        id="first_name"
                                        required
                                        v-model="user.first_name"
                                        icon="account"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('users.fields.last_name.name')" custom-class="mb-3"
                                         label-for="last_name"
                                         :type="errors.last_name ? 'is-danger' : null"
                                         :message="errors.last_name ? errors.last_name[0] : null">
                                    <b-input
                                        id="last_name"
                                        required
                                        v-model="user.last_name"
                                        icon="account"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('users.fields.pesel.name')" custom-class="mb-3"
                                         label-for="pesel"
                                         :type="errors.pesel ? 'is-danger' : null"
                                         :message="errors.pesel ? errors.pesel[0] : null">
                                    <b-input
                                        id="pesel"
                                        required
                                        v-model="user.pesel"
                                        icon="card-account-details-outline"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('users.fields.email.name')" custom-class="mb-3"
                                         label-for="email"
                                         :type="errors.email ? 'is-danger' : null"
                                         :message="errors.email ? errors.email[0] : null">
                                    <b-input
                                        required
                                        type="email"
                                        id="email"
                                        v-model="user.email"
                                        icon="at"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('auth.fields.password.name')" custom-class="mb-3"
                                         :type="errors.password ? 'is-danger' : null"
                                         :message="errors.password ? errors.password[0] : null">
                                    <b-input
                                        required
                                        type="password"
                                        placeholder="********"
                                        v-model="user.password"
                                        icon="lock"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('auth.fields.password_confirmation.name')"
                                         custom-class="mb-3"
                                         :type="errors.password_confirmation ? 'is-danger' : null"
                                         :message="errors.password_confirmation ? errors.password_confirmation[0] : null">
                                    <b-input
                                        required
                                        type="password"
                                        placeholder="********"
                                        v-model="user.password_confirmation"
                                        icon="lock"
                                    ></b-input>
                                </b-field>

                                <b-field class="checkbox-wrapper mb-3">
                                    <b-checkbox v-model="termsAccepted"
                                                required
                                                input-id="terms"
                                                true-value="1"
                                                false-value="0">
                                    </b-checkbox>
                                    <label class="label" for="terms">
                                        <i18n-t keypath="auth.sign_up.terms_and_conditions_consent" tag="span">
                                            <template #link>
                                                <a href="/regulamin" target="_blank">
                                                    {{ $t('auth.sign_up.terms_and_conditions_label') }}
                                                </a>
                                            </template>
                                        </i18n-t>
                                    </label>
                                </b-field>

                                <b-field class="checkbox-wrapper mb-3">
                                    <b-checkbox v-model="privacyAccepted"
                                                required
                                                input-id="privacy"
                                                true-value="1"
                                                false-value="0">
                                    </b-checkbox>
                                    <label class="label" for="privacy">
                                        <i18n-t keypath="auth.sign_up.privacy_policy_consent" tag="span">
                                            <template #link>
                                                <a href="/polityka-prywatnosci" target="_blank">
                                                    {{ $t('auth.sign_up.privacy_policy_label') }}
                                                </a>
                                            </template>
                                        </i18n-t>
                                    </label>
                                </b-field>

                                <div class="field pt-4">
                                    <button class="button is-success is-fullwidth" type="submit"
                                            v-bind:disabled="loading"
                                            v-bind:class="{'is-loading': loading}">
                                        {{ $t('actions.next') }}
                                    </button>
                                </div>
                            </div>
                        </form>

                        <form v-else-if="step === 2" @submit.prevent="submitStep2" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('auth.sign_up.title_label') }}
                            </p>
                            <div class="box no-top-radius">

                                <p class="mb-4">{{ $t('auth.sign_up.verification_code_hint', { email: user.email }) }}</p>

                                <b-field :label="$t('auth.fields.verification_code.name')" custom-class="mb-3"
                                         label-for="code"
                                         :type="errors.code ? 'is-danger' : null"
                                         :message="errors.code ? errors.code[0] : null">
                                    <b-input
                                        id="code"
                                        required
                                        v-model="verification.code"
                                        icon="shield-key"
                                    ></b-input>
                                </b-field>

                                <div class="field pt-4">
                                    <button class="button is-success is-fullwidth" type="submit"
                                            v-bind:disabled="loading"
                                            v-bind:class="{'is-loading': loading}">
                                        {{ $t('actions.register') }}
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
